function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { NativeModules } from 'react-native';
import { AnalyticsConnector } from '@amplitude/analytics-connector';
import { isNative } from '../util/platform';
export class DefaultUserProvider {
  constructor() {
    let baseProvider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _defineProperty(this, "baseProvider", void 0);

    _defineProperty(this, "nativeModule", NativeModules.ExperimentReactNativeClient);

    _defineProperty(this, "applicationContext", void 0);

    this.baseProvider = baseProvider;
    this.applicationContext = AnalyticsConnector.getInstance('context').applicationContextProvider.getApplicationContext();
  }

  async getUser() {
    var _this$baseProvider;

    let context;

    if (isNative()) {
      var _this$nativeModule;

      context = await ((_this$nativeModule = this.nativeModule) === null || _this$nativeModule === void 0 ? void 0 : _this$nativeModule.getApplicationContext());
    } else {
      context = this.applicationContext;
    }

    const baseUser = await ((_this$baseProvider = this.baseProvider) === null || _this$baseProvider === void 0 ? void 0 : _this$baseProvider.getUser());
    return { ...context,
      ...baseUser
    };
  }

}
//# sourceMappingURL=default.js.map